<template>
  <b-modal
    ref="modalReplicaConfiguracao"
    no-close-on-esc
    no-close-on-backdrop
    hide-footer
    title="Replicar configuração de modelo e documentos"
    title-class="tituloConfiguracao"
    @hide="hideModal"
  >
    <validation-observer ref="validacao">
      <b-row>
        <b-col cols="12">
          <grupo-empresarial-select
            v-model="form.grupoEmpresarial"
            @select="form.empresa = null"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <empresa-select
            v-model="form.empresa"
            :filtro-adicional="filtrarEmpresas"
            :require="true"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-btn
            size="sm"
            class="btn-sm btn-primary w-100"
            @click="iniciarProcesso"
          >
            Replicar
          </b-btn>
        </b-col>
      </b-row>
    </validation-observer>
  </b-modal>
</template>

<style lang="scss">
.tituloConfiguracao {
  font-size: 16px;
}
</style>

<script>
import { ValidationObserver } from 'vee-validate'

export default {
  name: 'ReplicarConfiguracaoModelo',
  components: {
    ValidationObserver,
    GrupoEmpresarialSelect: () => import('@/shared/components/grupoempresarial-select/GrupoEmpresarialSelect.vue'),
    EmpresaSelect: () => import('@/shared/components/empresa-select/EmpresaSelect.vue'),
  },
  props: {
    empresaId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      form: {
        grupoEmpresarial: null,
        empresa: null,
      },
    }
  },
  created() {
    this.$nextTick(() => {
      this.$refs.modalReplicaConfiguracao.show()
    })
  },
  methods: {
    hideModal() {
      this.$emit('fechar-modal-configuracao')
    },
    filtrarEmpresas(empresas) {
      let emp = []
      if (this.form.grupoEmpresarial && this.form.grupoEmpresarial.id > 0) {
        emp = empresas.filter(filt => filt.grupoEmpresarialId && filt.grupoEmpresarialId === this.form.grupoEmpresarial.id)
      } else {
        emp = empresas
      }

      emp = emp.filter(filt => filt.modeloId && filt.modeloId > 0 && filt.modeloAtivo)
      if (this.empresaId > 0) {
        const index = emp.findIndex(fin => fin.id === this.empresaId)
        if (index > -1) {
          emp.splice(index, 1)
        }
        return emp
      }
      return emp
    },
    iniciarProcesso() {
      this.$refs.validacao.validate()
        .then(success => {
          if (success) {
            this.$confirmar('Deseja replicar a configuração de Modelos e Documentos agora?',
              'Atenção: será replicado todos os documentos, inclusive os customizados! Ao clicar em confirmar, caso haja documentos vinculados na empresa atual estes serão removidos ou inativados e será mantido apenas os documentos replicados. Deseja continuar?',
              'question', 'danger')
              .then(result => {
                if (result.value) {
                  this.$refs.modalReplicaConfiguracao.hide()
                  this.$emit('iniciar-copia', this.form)
                }
              })
          }
        })
    },
  },
}
</script>
